export default __webpack_public_path__ + "static/media/expiredPagelllustration.140357bc.svg";